import { Yield } from '../../abacus/interfaces/yield.interface'

export const objectiveYields: Yield[] = [
  {
    label: 'Name',
    property: 'name'
  },
  {
    label: 'Description',
    property: 'description'
  }
]
